import {
  markdownLineStyleFor,
  markdownLineTextFor,
  parseMarkdownTextLines,
} from "../../../lib/markdown-text";
import { LinkifiedText } from "./linkified-text";

interface Props {
  readonly text: string;
}

// 付箋・テキストオブジェクトの非編集時に、本文（生の Markdown テキスト）を整形表示する。
// - 行単位のブロック記法のみ対応: 見出し（# 〜 ######）と箇条書き（- / * / +、ネスト対応）
// - 各行の本文は LinkifiedText を通して描画し、見出し・箇条書きの中でも URL の
//   自動リンク化（クリックで新規タブ）が従来どおり機能するようにする
// - スタイル・表示テキストの決定は markdown-text.ts に集約しており、付箋フォント自動調整の
//   計測ビルダー（buildMarkdownTextContent）と同じ行構造・テキスト内容になる
//   （構造一致はパリティテストで担保。リンクの <a>/<span> はインライン要素で行の
//   フォント計測へ影響しない）
// - 記法を含まない本文は全行 plain の div となり、従来の見た目（pre-wrap のプレーン表示 +
//   リンク化）と一致する
export function MarkdownTextView({ text }: Props): JSX.Element {
  const lines = parseMarkdownTextLines(text);
  return (
    <>
      {lines.map((line, index) => {
        const style = markdownLineStyleFor(line);
        const lineText = markdownLineTextFor(line);
        return (
          // 行は本文位置と 1:1 対応の静的リストで並べ替えが起きないため index key で問題ない。
          <div key={index} style={style}>
            {/* 空行は <br> で 1 行分の高さを維持する（空 div は高さ 0 になるため）。 */}
            {lineText.length > 0 ? <LinkifiedText text={lineText} /> : <br />}
          </div>
        );
      })}
    </>
  );
}
